/* eslint-disable max-lines */
import { Component, inject, input, output } from '@angular/core';
import {
  FilterData,
  PopulateAnalytics
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { RecentListItem } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  PredictiveSearch,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import { DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '../../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../../../models/book-widget-fields.interfaces';
import {
  DatepickerConfig,
  SelectedRange
} from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import { BookWidgetFilterDataService } from '../../../../services/book-widget-filter-data.service';

@Component({
  standalone: true,
  template: ''
})
export class ModifyBookWidgetBaseComponent {
  bookWidgetAem = input.required<BookWidgetAem>();
  bookWidgetFields = input.required<BookWidgetFields>();
  isAdvancedSearchExpanded = input(false);
  recentSearchList = input<RecentListItem[]>([]);
  savedSearchList = input<string[]>([]);
  searchModalTabs = input<Tab[]>([]);
  predictiveSearchData = input.required<PredictiveSearch>();
  isFullscreen = input.required<boolean>();
  datepickerConfig = input<DatepickerConfig>({} as DatepickerConfig);

  analyticsEvent = output<PopulateAnalytics>();
  infoIconClick = output<BookWidgetFieldInfoTypes>();
  bookWidgetFieldChange = output<BookWidgetFieldUpdateEvent>();
  swapClicked = output<number>();
  findFlight = output<void>();
  searchModalTriggerClicked = output<SelectedData>();
  searchModalEvent = output<SearchModalEvent<SearchModalEventType>>();
  addFlight = output<void>();
  removeFlight = output<void>();
  viewSearchOptionEvent = output<void>();
  toggleAdvSearchExpandedEvent = output<void>();
  filterDataService = inject(BookWidgetFilterDataService);
  protected mcRowsTrackByFn = (index: number) => index;
  protected get tripTypeOptions() {
    return TripTypeOptions;
  }

  protected get bookWidgetFieldInfoTypes() {
    return BookWidgetFieldInfoTypes;
  }

  protected get bookWidgetFieldUpdateTypes() {
    return BookWidgetFieldUpdateTypes;
  }

  protected onAddFlight() {
    this.addFlight.emit();
  }

  protected onRemoveFlight() {
    this.removeFlight.emit();
  }

  protected onViewSearchOptionsHandler() {
    this.viewSearchOptionEvent.emit();
  }

  protected collectFilterData(): FilterData[] {
    return this.filterDataService.collectFilterData(
      this.bookWidgetFields(),
      this.bookWidgetAem()
    );
  }

  onFindFlightClick(elementRef: HTMLElement) {
    this.findFlight.emit();
    const filters = this.collectFilterData();
    this.analyticsEvent.emit({
      el: elementRef,
      event: undefined,
      search: undefined,
      useAttrs: undefined,
      filters
    });
  }

  protected infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes) {
    if (sourceIcon) this.infoIconClick.emit(sourceIcon);
  }

  protected onDropdownSelectionChange(
    event: DropdownItem,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  protected onDateSelectionChange(
    event: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    index: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange: event,
        flightIndex: index
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  protected onCheckBoxChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  protected onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  protected onToggleChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
